<template>
    <div>
        <el-upload :action="oss.host"
                   :data="formData"
                   class="avatar-uploader"
                   accept=".jpg, .png, .jpeg, .PNG, .JPG, .JPEG, .mp4"
                   :show-file-list="showFileList"
                   :limit="limit"
                   :on-remove="remove"
                   :on-success="handleSuccess"
                   :before-upload="beforeAvatarUpload">
<!--            <img  :src="realProductUrl" class="avatar">-->
          <el-image
              v-if="realProductUrl&&!(realProductUrl.indexOf('.mp4')>-1)"
              class="avatar"
              :src="realProductUrl"
              fit="contain"></el-image>
            <video v-else-if="realProductUrl&&realProductUrl.indexOf('.mp4')>-1" :src="realProductUrl" class="avatar"></video>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>

    </div>

</template>

<script>
import ossApi from '../assets/api/oss'
export default {
  name: 'EeUpload',
  props:['url','miniUrl','showFileList'],
  data(){
    return {
      limit:undefined,
      loading:false,
      oss:{
        host:''
      },
      formData:{},
      realProductUrl: '',
      uploadedUrl:{}
    }
  },
  mounted(){
    if(this.showFileList){
      this.limit=1
    }else{
      this.limit=undefined
    }
    this.getOss()
    if(this.url) this.realProductUrl=this.url
  },
  watch:{
    url(newval){
      this.realProductUrl=newval
    }
  },
  methods:{
    remove(a,b){
      // console.log(a,b)
      this.realProductUrl=''
      this.$emit('getUrl','')
    },
    uuids () {
      let s = []
      let hexDigits = '0123456789abcdef'
      for (let i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
      }
      s[14] = '4'
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)
      s[8] = s[13] = s[18] = s[23] = '-'
      return s.join('')
    },
    beforeAvatarUpload (file) {
      console.log(file)
      this.loading=true
      this.formData.key = this.oss.dir + this.uuids() + '/' + file.name
      this.uploadedUrl = {
        key: this.formData.key,
        uid: file.uid
      }
      console.log(this.uploadedUrl)
    },
    handleSuccess (response, file) {
      console.log(file)
      let aa
      if (file.uid === this.uploadedUrl.uid) {
        this.realProductUrl = this.oss.host + '/' + this.uploadedUrl.key
        // this.realProductUrl = this.uploadedUrl.key

        if(this.miniUrl){
          aa = this.uploadedUrl.key
        }else{
          aa = this.oss.host + '/' + this.uploadedUrl.key
        }
      }
      console.log(this.realProductUrl,aa)
      this.$emit('getUrl',aa)
      this.loading=false
    },
    getOss(){
      ossApi.loadOSSToken(res => {
        // console.log(res)
        this.oss = res
        this.formData = {
          policy: res.policy,
          OSSAccessKeyId: res.accessid,
          success_action_status: '200',
          signature: res.signature,
          dir: res.dir
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/EeUpload.vue